<template>
  <tr>
    <td v-if="showDate">{{ formattedDate }}</td>
    <td v-if="loggedInUserHasAnyPermission('read_person')">
      <b-link :to="{ name: 'StudentWithGroup', params: { id: item.person.id, group: groupId } }" target="_blank">
        <i class="fa fa-fw fa-external-link"></i>
        {{ item.person.name }}
      </b-link>
    </td>
    <td v-else>
      {{ item.person.name }}
    </td>
    <td>{{ item.person.ssn }}</td>
    <td>
      <span v-if="item.has_special_needs" v-b-tooltip.hover :title="item.special_needs" class="text-danger" style="cursor: default">
        <i class="fa fa-fw fa-exclamation-circle"></i>
      </span>
    </td>
    <td>
      <span v-if="!item.hours"><i>Ekki skráð</i></span>
      <span v-else>{{ item.hours }}</span>
    </td>
    <td>
      <span v-if="item.sick_hours > 0">{{ item.sick_hours }}</span>
    </td>
    <td v-if="projectList.length > 0">
      {{ item.attendance_project ? item.attendance_project.name : '' }}
    </td>
    <td :class="item.period_max_hours !== null && item.period_max_hours - item.period_hours_total <= 10 ? 'text-danger' : ''">
      {{ item.period_hours_total }}
      <span v-if="item.period_max_hours">/{{ Number(item.period_max_hours) }}</span>
    </td>
    <td>
      {{ item.attendance_type ? item.attendance_type.name : '' }}
    </td>
    <td>
      <span v-b-tooltip.hover :title="item.comment">{{ item.comment | limitTo(20) }}</span>
    </td>
    <td>
      <a v-if="!batch && loggedInUserHasAnyPermission('write_attendance')" @click.prevent="$emit('edit', item)" style="cursor: pointer">
        <i class="fa fa-fw fa-pencil"></i>
      </a>
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'attendance-item',
  props: ['item', 'date', 'batch', 'projectList', 'groupId', 'showDate'],
  computed: {
    ...mapGetters(['loggedInUserHasAnyPermission']),
    formattedDate() {
      return this.date ? moment(this.date).format('DD.MM.YYYY') : '';
    },
  },
};
</script>

<style scoped></style>
